import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Modal } from '@/components/ui/modal';
import { Button } from '@/components/ui/button';
import { useArrangement } from '@/context/ArrangementContext';

export function EventDateModal({ onClose }: { onClose: () => void }) {
  const { arrangement, setArrangement } = useArrangement();
  const [date, setDate] = useState(arrangement?.date ?? '');
  const [saving, setSaving] = useState(false);

  if (!arrangement) return null;

  async function save(e: React.FormEvent) {
    e.preventDefault();
    if (!arrangement || !date) return;
    setSaving(true);
    const { error } = await setArrangement({ ...arrangement, date });
    setSaving(false);
    if (error) {
      toast.error('Kunne ikke lagre datoen');
      return;
    }
    toast.success('Datoen er lagret');
    onClose();
  }

  return (
    <Modal
      title={arrangement.date ? 'Endre dato' : 'Sett dato'}
      subtitle={arrangement.name}
      onClose={onClose}
      footer={
        <>
          <Button variant="outline" size="sm" onClick={onClose} disabled={saving}>
            Avbryt
          </Button>
          <Button
            type="submit"
            form="event-date-form"
            size="sm"
            className="gap-1.5 bg-navy hover:bg-navy/90 text-krem"
            disabled={!date || date === arrangement.date || saving}
          >
            {saving && <Loader2 className="w-3.5 h-3.5 animate-spin" />}
            Lagre
          </Button>
        </>
      }
    >
      <form id="event-date-form" onSubmit={save} className="flex flex-col gap-1.5">
        <label htmlFor="event-date" className="text-sm font-medium text-navy">
          Dato for arrangementet
        </label>
        <input
          id="event-date"
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          onFocus={(e) => e.target.showPicker()}
          className="w-full h-11 px-3 rounded-sm border border-border bg-white text-sm focus:outline-none focus:ring-2 focus:ring-navy text-foreground"
        />
      </form>
    </Modal>
  );
}
